"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeUndefinedFields = exports.objToScapedJSONString = exports.jsonToGraphQLQuery = exports.VariableType = exports.EnumType = void 0;
const json_to_graphql_query_1 = require("json-to-graphql-query");
Object.defineProperty(exports, "EnumType", { enumerable: true, get: function () { return json_to_graphql_query_1.EnumType; } });
Object.defineProperty(exports, "jsonToGraphQLQuery", { enumerable: true, get: function () { return json_to_graphql_query_1.jsonToGraphQLQuery; } });
Object.defineProperty(exports, "VariableType", { enumerable: true, get: function () { return json_to_graphql_query_1.VariableType; } });
function objToScapedJSONString(obj) {
    return obj ? `"${JSON.stringify(obj).replace(/"/g, '\\"')}"` : null;
}
exports.objToScapedJSONString = objToScapedJSONString;
function removeUndefinedFields(obj) {
    return Object.keys(obj).reduce((result, key) => typeof obj[key] === 'undefined' ? result : { ...result, [key]: obj[key] }, {});
}
exports.removeUndefinedFields = removeUndefinedFields;
//# sourceMappingURL=graphql.js.map